import React from 'react'
import moment from 'moment';

import ExpenseInvoiceTable from 'components/Invoices/ExpenseInvoiceTable';
import styles from 'components/Invoices/Invoice.module.scss';

class ExpenseInvoice extends React.Component {
  
  formatCurrency = (amount) => {
    return (new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount))
  }

  render = () => {
    return (
      <div className={styles.invoice}>
        <div className={styles.brand}>
          <img style={{ maxWidth: "100px", marginLeft:"42%", borderRadius: "50%"}} src={this.props.user.companyLogo} alt={this.props.user.name} />
        </div>
        <div className={styles.addresses}>
          <div>
            <div className={`${styles.valueTable} ${styles.to}`}>
              <div className={styles.row}>
                <div className={styles.label}>Invoice #</div>
                <div className={styles.value}>{this.props.info.displayId}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Employee Name</div>
                <div className={styles.value}>{this.props.info.employeeName}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Date</div>
                <div className={`${styles.value} ${styles.date}`}>{moment(this.props.info.paymentDate).format('DD/MM/YYYY')}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Description</div>
                <div className={styles.value}>{this.props.info.description}</div>
              </div>
            </div>
          </div>
          <div className={styles.from}>
            {/*<strong>Amazing Company</strong><br />
              123 Kensington Ave<br />
              Toronto, ON, Canada &nbsp;A1B2C3<br />
              416-555-1234*/
              this.props.user.companyInfo
            }
          </div>
        </div>
        <h2>Salary Slip</h2>
          <ExpenseInvoiceTable info={this.props.info} />
          <br></br>
        <div className={styles.totalContainer}>
          <form>
            <div className={styles.valueTable}>
              <div className={styles.row}>
                <div className={styles.label}>Approved By</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.props.user.name}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Total Salary</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.formatCurrency(this.props.info.total)}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Status</div>
                <div className={`${styles.value} ${styles.currency}`}>Paid</div>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
};

export default ExpenseInvoice;